<template>
  <div class="go-iuop-consult" :class="{'gray':isLogin,'white':!isLogin}" @click="goToIUOP">
    <template v-if="isIscoTheme">
      <img src="@/assets/login_images/consult_black.svg" class="consult-icon">
    </template>
    <template v-else>
      <svg-icon icon-class="monthly" class="monthly" />
    </template>
    <span>{{ $t('standard.consult') }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getEnvObj } from '@/utils/env'
import { isOS, isId, ISCO, ISCO_OS, ISCOUS, isVn } from '@/utils/constant'

export default {
  name: 'Consult',
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['language', 'userInfo', 'system_source']),
    isIscoTheme() {
      return [ISCO, ISCO_OS, ISCOUS].includes(this.system_source)
    },
  },
  methods: {
    goToIUOP() {
      if (isId()) {
        if (window._global['ENV'] === 'PRD') {
          window.location.href = `https://order-id.sf-express.com/#/customer-online?type=2`
        } else {
          window.location.href = `https://order-id.sit.sf-express.com/#/customer-online?type=2`
        }
      } else if (isVn()) {
        if (window._global['ENV'] === 'PRD') {
          window.location.href = `https://order-vn.sf-express.com/#/customer-online?type=2`
        } else {
          window.location.href = `https://order-vn.sit.sf-express.com/#/customer-online?type=2`
        }
      } else if (isOS()) {
        if (window._global['ENV'] === 'PRD') {
          window.location.href = `https://order.abxexpress.com.my/#/customer-online?type=2`
        } else {
          window.location.href = `https://order.sit.abxexpress.com.my/#/customer-online?type=2`
        }
      } else {
        const obj = getEnvObj()
        const lang = ['zh-CN', 'zh-HK', 'en', 'ja-JP'].includes(this.language) ? this.language : 'en'
        window.location.href = `${obj.IUOP_URL}/#/customer-online?lang=${lang}`
      }
      this.$track({ sceneType: 'Login', eventType: 'Click_On_Cooperation_Consultation' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.go-iuop-consult {
  cursor: pointer;
  top: 1px;
  position: relative;
  font-size: 14px;
  >svg{
    position: relative;
    top: -1px;
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
  }
  span{
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
  }
}
.gray{
  color: $color02;
}
.white{
  color: $color01;
}
.consult-icon {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  position: relative;
  top: -1px;
}
</style>
